import G from './Getters';

const sum = row => row.reduce((a,b) => a+b);

export default function getCropDropInfo(state,{cropIdsBeingDragged,figurePanelId,rowIndex}){

  if( !cropIdsBeingDragged || cropIdsBeingDragged.length === 0 ){
    return {};
  }

  let figurePanel = G.getFigurePanel(state,{figurePanelId});

  let gridIsEmpty = figurePanel.grid.length === 0;

  let numCols = figurePanel.grid[0].length;

  let structures;
  if( gridIsEmpty ){
    structures = [[1,15,1]];
  }else{
    structures = G.getAdjacentRowStructuresForAdding(state,{figurePanelId:figurePanel._id,rowIndex})
  }

  //structures = [ [ numCols ] ];

  let cellSpansMultipleRows = (
    rowIndex < 0 ? (
      Array(sum(structures[0])).fill(false)
    ) : (
      G.doCellsSpanMultipleRows(state,{rowIndex,figurePanelId:figurePanel._id})
    )
  )

  return {
    shouldRender:true,
    structures,
    cellSpansMultipleRows,
    gridIsEmpty,
    figurePanel
  }

}
